import { render } from "./MotivoRechazoForm.vue?vue&type=template&id=caf32b4e&scoped=true"
import script from "./MotivoRechazoForm.vue?vue&type=script&lang=js"
export * from "./MotivoRechazoForm.vue?vue&type=script&lang=js"

import "./MotivoRechazoForm.vue?vue&type=style&index=0&id=caf32b4e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-caf32b4e"]])

export default __exports__